define('view/controller/booking/datetime/BaseDateView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    /**
     * Base date picker view
     *
     * @class BaseDateView
     */
    return LayoutView.extend({

        collectionEvents: {
            'sync': 'render'
        },
        modelEvents: {
            'change': 'render'
        },

        _currentYear: null,
        _currentMonth: null,
        _dates: [],

        setCurrentYearMonth: function (year, month) {
            this._currentYear = year;
            this._currentMonth = month;
        },

        setSelectedDates: function (dates) {
            this._dates = dates;
        },

        getTimeDiff: function () {
            var diff = this.getOption('clientTimeZone').get('time_diff');
            var supportedTimelines = [
                Config.TIMELINE_SLOTS, Config.TIMELINE_CLASSES_PLUGIN, Config.TIMELINE_GRID_WEEKLY, Config.TIMELINE_SLOTS_WEEKLY
            ];
            if (!_.contains(supportedTimelines, Config.getInstance().getTimelineType())) {
                diff = 0;
            }
            return diff;
        }

    });

});
